import styled from "styled-components"
import { colors, fontSize, fontWeight } from "buoy-theme"

const Label = styled.h2`
  ${fontSize("label")};
  font-weight: ${fontWeight.medium};
  letter-spacing: 0.9px;
  text-transform: uppercase;
  line-height: 1.2;
  color: ${colors.neutralLight};
  margin: 10px 0 20px 0;
  display: inline-block;
  position: relative;
`

export { Label as default }



// WEBPACK FOOTER //
// ./src/components/Label/index.js